import * as React from 'react'
import {
  darkBlue,
  notificationLightBlue,
  notificationLightGreen,
  notificationLightRed,
} from '../../styles/material-ui-theme-v2'
import { fade } from '@material-ui/core/styles'
import makeStyles from '@material-ui/core/styles/makeStyles'

export type TNotificationType = 'warning' | 'success' | 'info'

export interface INotificationProps {
  children: React.ReactNode
  type: TNotificationType
  className?: string
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '14px',
    marginBottom: '24px',
    borderRadius: '8px',
    [theme.breakpoints.up('md')]: {
      padding: '16px',
    },
  },
  text: {
    fontWeight: 500,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: fade(darkBlue, 0.7),
    [theme.breakpoints.up('md')]: {
      fontSize: '0.875rem',
    },
  },

  warning: {
    backgroundColor: notificationLightRed,
  },
  success: {
    backgroundColor: notificationLightGreen,
  },
  info: {
    backgroundColor: notificationLightBlue,
  },
}))

export default function Notification(props: INotificationProps) {
  const { children, type, className } = props
  const classes = useStyles()

  const BEM = (): string => {
    const classArray = [classes.wrapper]

    switch (type) {
      case 'warning':
        classArray.push(classes.warning)
        break
      case 'success':
        classArray.push(classes.success)
        break
      case 'info':
        classArray.push(classes.info)
        break
    }

    if (className) {
      classArray.push(className)
    }

    return classArray.join(' ')
  }

  // Warnings announce assertively; success / info use polite status updates.
  const role = type === 'warning' ? 'alert' : 'status'
  const ariaLive = type === 'warning' ? 'assertive' : 'polite'

  return (
    <div className={BEM()} role={role} aria-live={ariaLive} aria-atomic="true">
      <div className={classes.text}>{children}</div>
    </div>
  )
}
